function MobileNav() {
  return (
    <nav className="mobile-nav">
      <a href="#home">Home</a>
      <a href="#products">Products</a>
      <a href="#shop">Shop</a>
      <a href="#contact">Contact</a>
    </nav>
  );
}

export default MobileNav;